export default __webpack_public_path__ + "images/se-22333e71c0c3e3d8da11f6e7985c622b.svg";